import {
  Get_All_Leads_Done_Deal_Only,
  Get_Error,
  Get_Total_Sales_And_Total_Commission_In_All_Months,
} from '../Types';

const intial = {
  LeadsForAccountant: [],
  ToalUnitPrices_AndCommission: [],
  loading: true,
};

const Accountant_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Get_All_Leads_Done_Deal_Only:
      return {
        ...state,
        LeadsForAccountant: action.payload,
        loading: false,
      };
    case Get_Total_Sales_And_Total_Commission_In_All_Months:
      return {
        ...state,
        ToalUnitPrices_AndCommission: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        LeadsForAccountant: action.payload,
      };
    default:
      return state;
  }
};

export default Accountant_Reducer;
